import { useTranslation } from 'react-i18next';

/**
 * Si un documento es de lectura obligatoria, para el listado.
 *
 * Es la diferencia entre un normativo que está publicado y uno que la caja
 * **tiene que poder demostrar** que el personal leyó, con su plazo corriendo.
 * Hasta ahora sólo se veía abriendo la ficha, así que revisar cuáles eran
 * obligatorios en un acervo de cuarenta y tantos significaba entrar a todos.
 *
 * **No depende del color.** El sello dice «obligatoria» y el plazo va al lado;
 * cuando no lo es, una raya — que es lo mismo que el portal usa en cualquier
 * celda sin dato, y no un hueco que parezca un fallo de carga.
 */
export function MarcaDeLectura({
  obligatoria,
  plazoEnDias,
}: {
  obligatoria: boolean;
  plazoEnDias?: number | undefined;
}) {
  const { t } = useTranslation();

  if (!obligatoria) {
    return (
      <span className="lectura-marca lectura-marca--no" title={t('documents.mandatoryOff')}>
        —
      </span>
    );
  }

  const titulo =
    plazoEnDias !== undefined
      ? t('documents.mandatoryWithDeadline', { days: plazoEnDias })
      : t('documents.mandatoryOn');

  return (
    <span className="lectura-marca" title={titulo} aria-label={titulo}>
      <svg viewBox="0 0 16 16" width="13" height="13" fill="none" stroke="currentColor" strokeWidth="1.6" aria-hidden="true">
        <path d="M3 2.5h7l3 3v8H3z" strokeLinejoin="round" />
        <path d="M9.5 2.5v3.5h3.5" strokeLinejoin="round" />
        <path d="M5.5 9.5 7 11l3.5-3.5" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
      {t('documents.mandatoryShort')}
      {/* El plazo, junto al sello: «obligatoria» sin plazo no dice para cuándo. */}
      {plazoEnDias !== undefined && (
        <span className="lectura-marca__plazo">{t('documents.daysShort', { days: plazoEnDias })}</span>
      )}
    </span>
  );
}
